import type * as Types from '../../../../graphql/generated-base';

import type { DocumentNode } from 'graphql';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from '@graphql/react-hooks';
export type MessagingDraftCountsByEventQueryVariables = Types.Exact<{
  eventId: Types.Scalars['ID'];
}>;

export type MessagingDraftCountsByEventQuery = {
  __typename?: 'Query';
  messageDraftsByEvent: Array<{ __typename?: 'MessageDraft'; id: string; messageBatchId: string; status: Types.MessageDraftStatus; scheduledAt?: any | null }>;
};

export const MessagingDraftCountsByEventDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'MessagingDraftCountsByEvent' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'eventId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'messageDraftsByEvent' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'eventId' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'eventId' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'messageBatchId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                { kind: 'Field', name: { kind: 'Name', value: 'scheduledAt' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useMessagingDraftCountsByEventQuery__
 *
 * To run a query within a React component, call `useMessagingDraftCountsByEventQuery` and pass it any options that fit your needs.
 * When your component renders, `useMessagingDraftCountsByEventQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMessagingDraftCountsByEventQuery({
 *   variables: {
 *      eventId: // value for 'eventId'
 *   },
 * });
 */
export function useMessagingDraftCountsByEventQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<MessagingDraftCountsByEventQuery, MessagingDraftCountsByEventQueryVariables>) {
  return ApolloReactHooks.useQuery<MessagingDraftCountsByEventQuery, MessagingDraftCountsByEventQueryVariables>(MessagingDraftCountsByEventDocument, baseOptions);
}
export function useMessagingDraftCountsByEventLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<MessagingDraftCountsByEventQuery, MessagingDraftCountsByEventQueryVariables>,
) {
  return ApolloReactHooks.useLazyQuery<MessagingDraftCountsByEventQuery, MessagingDraftCountsByEventQueryVariables>(MessagingDraftCountsByEventDocument, baseOptions);
}
export type MessagingDraftCountsByEventQueryHookResult = ReturnType<typeof useMessagingDraftCountsByEventQuery>;
export type MessagingDraftCountsByEventLazyQueryHookResult = ReturnType<typeof useMessagingDraftCountsByEventLazyQuery>;
export type MessagingDraftCountsByEventQueryResult = Apollo.QueryResult<MessagingDraftCountsByEventQuery, MessagingDraftCountsByEventQueryVariables>;
